<template>
  <v-dialog scrollable max-width="300px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn color="primary" text :disabled="disabled" v-on="on" @click="init"
          >AGREGAR BOLSA</v-btn
        >
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>NUEVA BOLSA</h4>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="validForm">

          <v-text-field
            label="Nombre"
            v-model="bolsa.nombre"
            :rules="[rules.required]"
          />
          <v-text-field
            label="Monto"
            v-model="bolsa.monto"
            :rules="[rules.required, rules.monto]"
          />

        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="close">Volver</v-btn>
        <v-btn color="info" @click="confirmar" :disabled="!validForm">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";


export default {
  components: {

  },
  props: {
    disabled: { type: Boolean, default: false },
    escenario: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      bolsa: {
        nombre: "",
        monto: null,
        escenario: { id: null },
        generacion: { id: null }
      },
      rules: {
        required: (value) => !!value || "Requerido.",
        monto: (value) => {
          if (value) {
            return (
              (value >= 0 && value <= 9000000000) || "Ingrese valor entre 0 y 9.000.000.000"
            );
          }
          return true;
        },
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
    };
  },
  mounted() {
    this.nuevoMonto = this.monto;
  },
  methods: {
    init() {

    },
    close() {
      this.$refs.form.resetValidation();
      this.showDialog = false;
    },
    confirmar() {
      console.log(this.escenario);
      this.bolsa.escenario = this.escenario;
      this.bolsa.generacion = this.escenario.generacion;
      axios
        .put("/bolsa/", this.bolsa)
        .then((response) => {
          console.log(response);
          this.$emit("actualizado");
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.nuevaCedula = this.cedula;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    }
  },
};
</script>